var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa-bookmark text-warning",class:_vm.css,on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }